import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import ProgressBar from './touchpoint-progressbar';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const useStyles = makeStyles({
    primary: {
        fontSize: 16,
    },
    primaryLight: {
        color: '#fff'
    },
    primaryDark: {
        color: '#96A0B9',
        fontWeight: 700
    },
});

const Touchpoint = ({ text, voice, theme }) => {
    const classes = useStyles();
    const muiTheme = useTheme();
    const matches = useMediaQuery(muiTheme.breakpoints.down('lg'));
    let SIZE = 40;
    if (matches) {
        SIZE = 30;
    }

    return (
        <Box display="flex" alignItems="center" justifyContent="center">
            <Typography className={clsx(classes.primary, theme ? classes.primaryLight: classes.primaryDark)} theme={theme}>{text.value}</Typography>

            <Box display="flex" mx={2} flexGrow={1}>
                <ProgressBar position="left" value={text.value}  type={text.type} size={SIZE} theme={theme} />
                <Box width={theme ? "2px": "5px"} bgcolor={theme ? "#000": "#DDE0E8"} height={SIZE}></Box>
                <ProgressBar position="right" value={voice.value}  type={voice.type} size={SIZE} theme={theme}/>
            </Box>
            
            <Typography className={clsx(classes.primary, theme ? classes.primaryLight: classes.primaryDark)} theme={theme}>{voice.value}</Typography>
        </Box>
    )
}

export default Touchpoint;
